import isValidEmail from 'utils/text/isValidEmail';
const isEmailValid = email => isValidEmail(email ?? '');
const showEmailError = email => {
  if (email.length > 0) return email !== undefined && !isEmailValid(email);
  return false;
};
export default showEmailError;